/**
 * 蜘蛛預製物件
 * 代表遊戲中的蜘蛛角色，包含多方向動畫和點擊音效
 */
export default class Spider extends Phaser.Sprite {

  /**
   * 創建蜘蛛實例
   * @param {Phaser.Game} game - Phaser遊戲實例
   * @param {number} x - 初始X座標
   * @param {number} y - 初始Y座標
   */
  constructor(game, x, y) {
    super(game, x, y, 'spider', 0);

    this.inputEnabled = true;

    // 設置所有方向的動畫
    this.setupAllAnimations();

    // 播放預設動畫
    // this.animations.play('walk_top', 16, true);

    // 設置點擊事件
    this.setupClickHandler();
  }

  /**
   * 設置所有方向的動畫
   * 包括站立、行走、跳躍、死亡、翻轉和攻擊動畫
   */
  setupAllAnimations() {
    const directions = [
      { start: 0, name: '_left' },
      { start: 32, name: '_top_left' },
      { start: 64, name: '_top' },
      { start: 96, name: '_top_right' },
      { start: 128, name: '_right' },
      { start: 160, name: '_bottom_right' },
      { start: 192, name: '_bottom' },
      { start: 224, name: '_bottom_left' }
    ];

    directions.forEach(dir => {
      this.createAnimations(dir.start, dir.name);
    });
  }

  /**
   * 為特定方向創建動畫
   * @param {number} startFrame - 起始幀索引
   * @param {string} direction - 方向名稱後綴
   */
  createAnimations(startFrame, direction) {
    // 站立動畫（4幀）
    this.animations.add('stand' + direction, Phaser.ArrayUtils.numberArray(startFrame, startFrame + 3));

    // 行走動畫（8幀）
    this.animations.add('walk' + direction, Phaser.ArrayUtils.numberArray(startFrame + 4, startFrame + 4 + 7));

    // 跳躍動畫（4幀）
    this.animations.add('jump' + direction, Phaser.ArrayUtils.numberArray(startFrame + 12, startFrame + 12 + 3));

    // 死亡動畫（8幀）
    this.animations.add('die' + direction, Phaser.ArrayUtils.numberArray(startFrame + 16, startFrame + 16 + 7));

    // 翻轉動畫（4幀）
    this.animations.add('flip' + direction, Phaser.ArrayUtils.numberArray(startFrame + 24, startFrame + 24 + 3));

    // 攻擊動畫（4幀）
    this.animations.add('attack' + direction, Phaser.ArrayUtils.numberArray(startFrame + 28, startFrame + 28 + 3));
  }

  /**
   * 設置點擊事件處理
   * 點擊時播放隨機音效
   */
  setupClickHandler() {
    this.events.onInputDown.add(() => {
      const soundName = Phaser.Utils.chanceRoll(50) ? 'fart-01' : 'fart-03';
      this.game.sound.play(soundName);
    }, this);
  }

  /**
   * 更新循環
   * 處理蜘蛛的移動邏輯
   */
  update() {
    // 垂直移動
    this.y -= 2;

    // 當蜘蛛移出螢幕頂部時，重置到底部
    if (this.y < -300) {
      this.y = this.game.world.height + 200;
    }

    // 水平移動：使用正態分佈產生自然的左右搖擺效果
    this.x -= this.game.rnd.normal() * 1;
  }
}
